module.exports = __webpack_public_path__ + "img/orgInfo.18bc755e.svg";